import styled from 'styled-components'

const LoginCard = styled.div.attrs({ className: 'card' })`
  /* width: 450px; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const LoginCardContainer = styled.div`
  width: 100%;
  height: 100%;
  @media screen and (min-width: 400px) {
    max-width: 320px;
  }
`

export default LoginCard



// WEBPACK FOOTER //
// ./src/components/templates/login/LoginCard.js